import { createFileRoute } from "@tanstack/react-router";
import { ogImageMeta } from "@/lib/seo/og-image";
import { pageSchemas } from "@/lib/seo/page-schema";
import { BrandManagersPersonaPageBG } from "@/components/site/BrandManagersPersonaPageBG";
import { BRAND_MANAGERS_META_DESCRIPTION_BG } from "@/content/meta/BrandManagersPersonaPageBG";

export const Route = createFileRoute("/bg/who-we-help/brand-managers")({
  head: () => ({
    meta: [
      { title: "Медийно разузнаване за бранд мениджъри | Perceptica" },
      { name: "description", content: BRAND_MANAGERS_META_DESCRIPTION_BG },

      { property: "og:title", content: "Медийно разузнаване за бранд мениджъри | Perceptica" },
      { property: "og:description", content: BRAND_MANAGERS_META_DESCRIPTION_BG },
      { name: "twitter:card", content: "summary_large_image" },
      { name: "twitter:title", content: "Медийно разузнаване за бранд мениджъри | Perceptica" },
      { name: "twitter:description", content: BRAND_MANAGERS_META_DESCRIPTION_BG },
      { property: "og:url", content: "https://perceptica.com/bg/who-we-help/brand-managers" },
      ...ogImageMeta("bg", "/who-we-help/brand-managers"),
      { property: "og:type", content: "website" },
    ],
  
    scripts: pageSchemas({ locale: "bg", path: "/who-we-help/brand-managers" }),
  }),
  component: BrandManagersPersonaPageBG,
});
